<oui-document-viewer [documentUrl]="documentUrl" [showControls]="true">
  <ng-container oui-document-controls>
    <lib-document-viewer-header
      [documentName]="headerDocumentName"
      [fileName]="fileMetadata?.fileName ?? ''"
      [dateAjout]="$safeNavigationMigration(fileMetadata?.dateDeDerniereModification)"
      [menu]="fileMenu"
      (close)="close.emit()">
    </lib-document-viewer-header>

    @if (commentaire) {
      <div class="flex-vertical">
        <div class="body-2 color-on-surface-medium">Commentaire</div>
        <div class="body-2 color-on-surface-emphasis" [innerText]="commentaire"></div>
      </div>
    }

    @if (fichierOperationStatut?.statut == compliant) {
      <app-file-conform-status-stamp [historyEntries]="historyEntries"></app-file-conform-status-stamp>
    }
    @if (!!nCtoDisplayList && nCtoDisplayList.length) {
      <app-non-conformite-accordion
        [NCs]="nCtoDisplayList"
        [isShowMenu]="false"
      [title]="ncTitle"></app-non-conformite-accordion>
    }
  </ng-container>
</oui-document-viewer>
